/**
 * Verified Badge
 * Small blue check shown next to verified users' names.
 */

import React from 'react';
import { BadgeCheck } from 'lucide-react';

const VerifiedBadge = ({ size = 16 }) => (
  <BadgeCheck
    size={size}
    className="verified-badge"
    aria-label="Verified"
  />
);

export default VerifiedBadge;
